export const getFullAddress = (seller) => {
    if (!seller) return "ไม่ระบุที่อยู่";

    if (seller.address) {
        const addr = seller.address;
        const subDist = addr.subDistrict;
        const dist = subDist?.district;
        const prov = dist?.province;

        let address = addr.detail || "";
        if (subDist?.nameTh) address += ` ต.${subDist.nameTh}`;
        if (dist?.nameTh) address += ` อ.${dist.nameTh}`;
        if (prov?.nameTh) address += ` จ.${prov.nameTh}`;
        if (subDist?.zipcode) address += ` ${subDist.zipcode}`;
        return address.trim() || "ไม่ระบุที่อยู่";
    }

    let address = seller.addressDetail || "";
    if (seller.subdistrict) address += ` ต.${seller.subdistrict}`;
    if (seller.district) address += ` อ.${seller.district}`;
    if (seller.province) address += ` จ.${seller.province}`;
    if (seller.postalCode) address += ` ${seller.postalCode}`;
    return address.trim() || "ไม่ระบุที่อยู่";
};

export const getAddress = (seller) => {
    if (!seller || !seller.address) return { provinceName: "ไม่ระบุจังหวัด" };

    const addr = seller.address;
    const subDist = addr.subDistrict;
    const dist = subDist?.district;
    const prov = dist?.province;

    return {
        address: addr,
        subDistrict: subDist,
        district: dist,
        province: prov,
    };
};